<template>
    <img ref="gifImage" class="left-image" :src="src" alt="">
</template>

<script>
import Freezeframe from 'freezeframe';

export default {
    props: {
        src: String
    },
    mounted() {
        this.freezeGif();
    },
    methods: {
        freezeGif() {
            setTimeout(() => {
                const freezeframeInstance = new Freezeframe({
                    selector: this.$refs.gifImage,
                    trigger: false,
                });
            }, 1170);
        },
    }
}
</script>
